module.exports = __webpack_public_path__ + "static/img/200057.19cece96.png";